module.exports = __webpack_public_path__ + "static/media/html.7cba39f9.svg";